import {userService} from 'services';
import {SET_NEED_QUICKSTART} from 'store/modules/user/user';

export const SET_QUICKSTART_COMPLETE = 'SET_QUICKSTART_COMPLETE';

const quickstartAbortController = new AbortController();

const quickstartStore = {
  namespaced: true,
  state () {
    return {};
  },
  getters: {
    quickstartAccount (state, getters, rootState, rootGetters) {
      const debugWizardAccount = JSON.parse(localStorage.getItem('show-quickstart'));
      if (debugWizardAccount) {
        const existingAccount = rootGetters['sidebar/getAccountById'](debugWizardAccount);
        if (!existingAccount) {
          // debug account may not be fetched
          return;
        }
        return {account: debugWizardAccount, debug: true};
      }
      if (!rootGetters['user/currentUser'].need_quickstart) {
        return null;
      }

      const rootAccounts = rootGetters['sidebar/getChildAccountsById'](null);
      if (rootAccounts.length > 0) {
        return {account: rootAccounts[0].id, debug: false};
      }
    }
  },
  mutations: {

  },
  actions: {
    async [SET_QUICKSTART_COMPLETE] (context) {
      const debugWizardAccount = JSON.parse(localStorage.getItem('show-quickstart'));
      if (debugWizardAccount) {
        localStorage.setItem('show-quickstart', JSON.stringify(null));
        return;
      }

      await userService.quickstartFinish({
        signal: quickstartAbortController.signal
      });

      context.dispatch(`user/${SET_NEED_QUICKSTART}`, false, {root: true});
    }
  }
};

export default quickstartStore;
